import { render, staticRenderFns } from "./BuatPassword.vue?vue&type=template&id=fe0214e4&scoped=true"
import script from "./BuatPassword.vue?vue&type=script&lang=js"
export * from "./BuatPassword.vue?vue&type=script&lang=js"
import style0 from "./BuatPassword.vue?vue&type=style&index=0&id=fe0214e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0214e4",
  null
  
)

export default component.exports